import { cellStyle, mathRound } from "../core/helper/UtilHelper";

const GaitaTable = (props: any) => {
  return (
    <table
      style={{
        width: "100%",
        textAlign: "center",
        borderCollapse: "collapse",
        border: "1px solid #dddddd",
        margin: "1em 0px 1em 0px",
      }}
    >
      <thead>
        <tr style={cellStyle}>
          <th colSpan={2} style={cellStyle}>
            Gaita Elek Analizi
          </th>
          <th colSpan={2} style={cellStyle}>
            Padok İsmi : {props.gaitaTable.padokName}
          </th>
          <th colSpan={1} style={cellStyle}>
            Numune (gr) : {props.gaitaTable.sample}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr style={cellStyle}>
          <th style={cellStyle}>Elek İsmi</th>
          <th style={cellStyle}>Ref (%)</th>
          <th style={cellStyle}>Ref (gr)</th>
          <th style={cellStyle}>Sonuç (%)</th>
          <th style={cellStyle}>Sonuç (gr)</th>
        </tr>
        <tr style={cellStyle}>
          <td style={cellStyle}>1. Elek</td>
          <td style={cellStyle}>{"<%10"}</td>
          <td style={cellStyle}>{mathRound(props.gaitaTable.sample * 0.1)}</td>
          <td
            style={{
              ...cellStyle,
              backgroundColor:
                (props.gaitaTable.firstSieve / props.gaitaTable.sample) * 100 <=
                10
                  ? "#92d050"
                  : "#fc0404",
            }}
          >
            %
            {props.gaitaTable.sample > 0
              ? mathRound(
                  (props.gaitaTable.firstSieve / props.gaitaTable.sample) * 100
                )
              : 0}
          </td>
          <td>{props.gaitaTable.firstSieve}</td>
        </tr>
        <tr style={cellStyle}>
          <td style={cellStyle}>2. Elek</td>
          <td style={cellStyle}>{"<%20"}</td>
          <td style={cellStyle}>{mathRound(props.gaitaTable.sample * 0.2)}</td>
          <td
            style={{
              ...cellStyle,
              backgroundColor:
                (props.gaitaTable.secondSieve / props.gaitaTable.sample) *
                  100 <=
                20
                  ? "#92d050"
                  : "#fc0404",
            }}
          >
            %
            {props.gaitaTable.sample > 0
              ? mathRound(
                  (props.gaitaTable.secondSieve / props.gaitaTable.sample) * 100
                )
              : 0}
          </td>
          <td>{props.gaitaTable.secondSieve}</td>
        </tr>
        <tr style={cellStyle}>
          <td style={cellStyle}>3. Elek</td>
          <td style={cellStyle}>{">%50"}</td>
          <td style={cellStyle}>{mathRound(props.gaitaTable.sample * 0.5)}</td>
          <td
            style={{
              ...cellStyle,
              backgroundColor:
                (props.gaitaTable.thirdSieve / props.gaitaTable.sample) * 100 >
                50
                  ? "#92d050"
                  : "#fc0404",
            }}
          >
            %
            {props.gaitaTable.sample > 0
              ? mathRound(
                  (props.gaitaTable.thirdSieve / props.gaitaTable.sample) * 100
                )
              : 0}
          </td>
          <td>{props.gaitaTable.thirdSieve}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default GaitaTable;
